import  { SEND_ENQUIRY } from '../../actions/actionTypes'

export default function(state = {}, action) {
    switch (action.type) {
      case SEND_ENQUIRY :
        return {
          ...state,
          msg: action.payload,
          enquirySend: true
        }  
      default:
        return state;
    }
  }